import {Injectable} from "@angular/core";
 
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap} from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class StatService {


 private global_id = null
 private local_id = null
 private geoLocation = null	 
  constructor(private http: HttpClient){
    const potentialToken = localStorage.getItem('gs')
    if(potentialToken !== null){
      this.setGlobalSession(potentialToken)
    }
    const loc = localStorage.getItem('gl')
    if(loc !== null){
      this.setGeoSession(loc)
    }

 
  }


	

   setGeoSession(geoLocation: string){
    this.geoLocation = geoLocation
  }

  getGeoSession():string{
    return this.geoLocation
  }

  hasGeoSession(){
    return !!this.geoLocation
  } 

  createGeoSession(geoLocation){
     this.setGeoSession(geoLocation)
     localStorage.setItem('gl',geoLocation)
  } 

  removeGeoSession(id){
     localStorage.removeItem('gl')
     this.geoLocation = null
  } 




  setGlobalSession(global_id: string){
    this.global_id = global_id
  }

  getGlobalSession():string{
    return this.global_id
  }

  hasGlobalSession(){
    return !!this.global_id
  } 

  createGlobalSession(global_id){
     this.setGlobalSession(global_id)
     localStorage.setItem('gs',global_id)
  } 

  removeGlobalSession(id){
     localStorage.removeItem('gs')
     this.global_id = null
  } 




  setLocalSession(local_id: string){
    this.local_id = local_id
  }

  getLocalSession():string{
    return this.local_id
  }

  hasLocalSession(){
    return !!this.local_id
  } 

  createLocalSession(local_id){
     this.setLocalSession(local_id)
  } 

  removeLocalSession(id){
     this.local_id = null
  } 
 

}
